import useSWR, { mutate as globalMutate } from "swr";
import { API } from "../utils/constants";
import { authFetcher } from "./fetcher";

/**
 * useAdminVehicles — Fetches all vehicles for admin management.
 *
 * API: GET /api/admin/vehicles → AdminVehicleDto[] (CON-002 §8)
 * Requires Bearer token (authed fetcher, DEF-010).
 *
 * @returns {{ vehicles: Array, error: any, isLoading: boolean, mutate: Function }}
 */
export function useAdminVehicles() {
  const { data, error, isLoading, mutate } = useSWR(
    API.ADMIN.VEHICLES.LIST,
    authFetcher,
    { revalidateOnFocus: false }
  );

  return { vehicles: data ?? [], error, isLoading, mutate };
}

/**
 * invalidateAdminVehicles — Force-revalidates the admin vehicles SWR cache.
 * @returns {Promise<any>}
 */
export const invalidateAdminVehicles = () =>
  globalMutate(API.ADMIN.VEHICLES.LIST);
